import React from "react";
import { RightArrowIcon } from "../../../styles/img/svg/RightArrowIcon";
// import { RetryIcon } from "../../../styles/img/svg/RetryIcon";
import {
  commonConstants,
  schedulePaymentsConstants,
} from "../../../_redux/_constants";
import moment from "moment";
import NumberFormatter from "../../../_helpers/numberFormatter";

export const UiSchedulePaymentIterationCard = (props) => {
  const { iterationData, onClick, scheduleSummary } = props;

  const cardClassName =
    iterationData?.draft || iterationData?.read
      ? `df-fav-item df-bill-fav-card df-schedule-payments-card df-draft-read`
      : `df-fav-item df-bill-fav-card df-schedule-payments-card`;

  return (
    <>
      <div className={cardClassName}>
        <div className="df-fav-item__title df-bill-fav-card__title">
          <h4>
            {scheduleSummary?.scheduledPaymentName ||
              scheduleSummary?.references}
          </h4>
          <p className="df-sec-m-card-msg-short">
            {NumberFormatter(
              scheduleSummary?.scheduledPaymentType === schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_TRANSFER ?
                scheduleSummary?.amount : scheduleSummary?.customerNearestChargeAmountInBaseCur,
              scheduleSummary?.scheduledPaymentType === schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_TRANSFER ?
                scheduleSummary?.currencyAfterConvert : scheduleSummary?.currencyBeforeConvert,
            )}
          </p>
          <p className="df-sec-m-card-date">{`Scheduled for - ${moment(iterationData?.iterationDate).format(commonConstants.COMMON_DATE_FORMAT_DD_MMM_YYYY_SLASH)}`}</p>
        </div>

        {iterationData?.iterationStatus?.name ? (
          <div className="df-fd-account-card-wr">
            {iterationData?.iterationStatus?.name ===
              schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_ACTIVE &&
              iterationData?.status?.name !==
                schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_FAIL &&
              iterationData?.status?.name !==
                schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_SUCCESS && (
                <label className="df-lbl-pending">ACTIVE</label>
              )}

            {iterationData?.iterationStatus?.name ===
              schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_STOPPED && (
              <label className="df-lbl-canceled">STOPPED</label>
            )}

            {iterationData?.status?.name ===
              schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_SUCCESS &&
              iterationData?.iterationStatus?.name ===
                schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_COMPLETED && (
                <label className="df-lbl-success">SUCCESS</label>
              )}

            {/* FAILED variants */}
            {iterationData?.status?.name ===
              schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_FAIL && (
              <label className="df-lbl-declined">FAILED</label>
            )}

            {/* will be used for failed payments */}
            {/* {iterationData.schedulePaymentType === "FAILED" &&
              iterationData.retryStatus === "success" && (
                <div className="df-schedule-status-wrap df-schedule-status-wrap--success">
                  <label className="df-lbl-declined">FAILED</label>
                  <p className="df-schedule-retry-success">Retry Successful</p>
                </div>
              )} */}

            {/* {iterationData.schedulePaymentType === "FAILED" &&
              iterationData.retryStatus === "retry" && (
                <div className="df-schedule-status-wrap df-schedule-status-wrap--retry">
                  <button
                    type="button"
                    className="df-schedule-retry-btn"
                    onClick={iterationData.onRetry}
                  >
                    <span>Retry</span>
                    <RetryIcon />
                  </button>
                  <label className="df-lbl-declined">FAILED</label>
                </div>
              )} */}
          </div>
        ) : (
          ""
        )}
        <RightArrowIcon className="df-bill-fav-card__arrow" onClick={onClick} />
      </div>
    </>
  );
};
